import React from 'react';
import ChipList from './ChipList';

/**
 * Thin `ChipList` wrapper for rendering a product's selected regions as PANWDS `Tag`
 * chips, used by `PlaneRegionRow` inside `ManageSubscriptionsModal`.
 *
 * `regions` are the raw `city-*` values produced by the region TreeSelects -- every
 * TreeSelect runs with `treeListProps={{ onlyLeafChecked: true }}`, so `country-`/
 * `continent-` prefixes can never appear here.
 *
 * `onRemove` is optional: when omitted, chips render without a close button. When
 * provided, it is called with the raw `city-*` value for the removed chip.
 */
const RegionChipList = ({
    regions,
    isExpanded,
    onToggleExpand,
    onRemove,
    testIdPrefix,
    collapsedLimit = 10,
}) => (
    <ChipList
        items={regions}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
        onRemove={onRemove}
        testIdPrefix={testIdPrefix}
        collapsedLimit={collapsedLimit}
        formatLabel={(value) => value.replace('city-', '')}
        emptyLabel="No regions selected"
    />
);

export default React.memo(RegionChipList);
